import React from 'react';
import { useTranslation } from 'react-i18next';
import { formatPrice } from 'utils/numberFormatter';
import { QuotationSummaryData } from '../../models/quotations/Quotations';
import { formatDate } from '../../utils/dateFormatter';
export const QuotationDetailsSummary: React.FC<{
    quote: QuotationSummaryData;
}> = (props) => {
    const { quote } = props;
    const { t } = useTranslation('quotations', {
        keyPrefix: 'QUOTATIONS.QUOTATION_DETAILS.SUMMARY',
    });

    return (
        <div>
            <div>
                {t('BUYER_NAME')}: <b>{quote.buyer?.name}</b>
            </div>
            <div>
                {t('TOTAL_MARGIN')}:{' '}
                <b>
                    {formatPrice(
                        quote.items.reduce((sum, item) => {
                            sum += item.margin * item.quantity;
                            return sum;
                        }, 0)
                    )}{' '}
                    Ft
                </b>
            </div>
            <div>
                {t('CREATED_AT')}: <b>{formatDate(quote.valid_from)}</b>
            </div>
            <div>
                {t('EXPIRED_DATE')}: <b>{formatDate(quote.valid_until)}</b>
            </div>
        </div>
    );
};
